import { createFileRoute } from '@tanstack/react-router';
import { AutomationPage } from '@/features/settings/AutomationPage';

export const Route = createFileRoute('/app/settings/automation')({
  component: AutomationPage,
  staticData: { title: 'Automation · Settings' },
});
